module.exports = __webpack_public_path__ + "static/media/transporter-empty.8903d9f3.svg";